
import Vue from 'vue'
import { RIcon, RButton } from '@/components'

export default Vue.extend({
  name: 'GoToButtonLink',
  components: {
    RIcon,
    RButton,
  },
  props: {
    to: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
    },
    stroke: {
      type: String,
    },
  },
})
